<template>
  <div>
    <p class="text-center text-2xl"><strong>EMHUB用户服务协议</strong></p>
    <p class="mt-5"><strong>一、声明</strong></p>
    <p class="mt-2">
      欢迎使用北京欧心医联医疗科技有限公司产品：欧洲医疗服务中心服务平台及EMHUB（以下统称EMHUB）。为了保障用户的权益，请在使用EMHUB之前，详细阅读本协议中所有条款内容。您应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。在您初次登录前，按照页面提示“点击登录即表示您已阅读并同意《EMHUB用户服务协议》各条款内容”并进行选择，如果您点击［登录］则视为您已阅读并接受本协议所有条款，包括接受更新后的本协议条款，如发生纠纷，应以最新的服务协议为判断标准。如果您对本协议任何条款或者将来随时可能修改、补充的条款有异议，您可以选择不登录成为EMHUB用户，也无法享受EMHUB提供的各种服务。
    </p>
    <p class="mt-5"><strong>二、注册信息及隐私保护</strong></p>
    <p class="mt-2">
      1．EMHUB采用直接登录的方式，首次登录成功即表示您已注册成为EMHUB合法用户。在初次登录时，务必审慎阅读本协议条款。
    </p>
    <p class="mt-2">
      2．EMHUB提供多种登录方式，选择手机号登录，请务必保管好您的验证码短信和您所设置的密码，且要对任何以您账号进行的所有活动和事件负全责，您有权随时根据指示更改您的密码；若授权第三方登录，EMHUB将会获取您的第三方应用信息，是否授权第三方登录方式登录，请谨慎考虑。
    </p>
    <p class="mt-2">
      3．登录成为EMHUB用户后，您的隐私将受EMHUB保护，我们保证不对外公开或向第三方提供您的注册资料及您在使用本服务时存储在EMHUB的非公开内容，但以下条款除外：
    </p>
    <p class="mt-2">（1）事先获得您的明确授权；</p>
    <p class="mt-2">（2）您选择公开或授权第三方使用；</p>
    <p class="mt-2">（3）根据相关政府主管部门的要求；</p>
    <p class="mt-2">（4）为维护社会公众的利益；</p>
    <p class="mt-2">（5）为维护EMHUB的合法权益。</p>
    <p class="mt-2">
      4．若发现任何非法使用您的账号或存在安全漏洞的情况，请立即通知EMHUB工作人员。因黑客行为或您的管疏忽等情况导致账号、验证码或密码遭他人非法使用，EMHUB不承担责任。
    </p>
    <p class="mt-5"><strong>三、平台服务内容</strong></p>
    <p class="mt-2">
      1．EMHUB提供的服务仅向能够根据相关法律订立具有法律约束力的合约的个人、企业和社会团体提供。因此，您应保证在使用EMHUB专项特定服务时，务必提供真实、详尽、有效和准确的个人资料。
    </p>
    <p class="mt-2">
      2．EMHUB平台有义务维护网上平台的正常、安全、稳定运行，并努力提升和改进技术，使用户网上活动得以顺利进行；
    </p>
    <p class="mt-2">
      3．对用户在注册和应用上反馈的问题及反映的情况，EMHUB平台会及时做出回复；
    </p>
    <p class="mt-2">
      4．EMHUB对其平台发布的内容应尽量严格审核，如出现违规、非法等信息，望用户尽早告知EMHUB客服，我们会在第一时间对此进行处理，用户也应当对所获取的内容进行判断，若涉及到个人损失或损害，EMHUB不承担任何责任。
    </p>
    <p class="mt-2">
      5．EMHUB所提供的服务中如涉及到个人信息交换、金钱交易时，可能存在风险和瑕疵，用户应谨慎判断，EMHUB不做任何担保。用户间达成的协议，纠纷和损失由用户自行承担。
    </p>
    <p class="mt-2">
      6．对于用户在EMHUB平台网站上做出下列行为的，EMHUB平台有权做出删除相关信息、终止提供服务等处理，而无须征得用户同意：
    </p>
    <p class="mt-2">
      （1）EMHUB平台有权对用户的注册信息及相关行为进行查阅，发现注册信息或相关行为中存在任何问题的，有权向用户发出询问及要求改正的通知或者做出删除等处理；
    </p>
    <p class="mt-2">
      （2）用户违反本协议规定或有违反法律法规和地方规章的行为的，EMHUB平台有权停止传输并删除其信息，禁止用户发言，注销用户账户并按照相关法律规定向相关主管部门进行披露；
    </p>
    <p class="mt-2">
      （3）对于用户在EMHUB平台进行的下列行为，EMHUB平台有权对用户采取删除其信息、禁止用户发言、注销用户账户等限制性措施：包括发布或以电子邮件、短信等其他方式传送存在恶意、虚假和侵犯他人人身财产权利内容的信息，将有关干扰、破坏或限制任何计算机软件、硬件或通讯设备功能的软件病毒或其他计算机代码、档案和程序等资料，加以上载、发布、发送电子邮件或以其他方式传送，干扰或破坏EMHUB平台网站和服务或与平台相连的服务器和网络，或发布其他违反公共利益或可能严重损害EMHUB平台和其他用户合法利益的信息。
    </p>
    <p class="mt-5"><strong>四、知识产权与其他合法权益</strong></p>
    <p class="mt-2">
      1．EMHUB所提供的服务中涉及到的品牌图片、文字或其他EMHUB标志、产品及服务名称，其著作权或商标权归EMHUB所有。未经EMHUB书面授权同意，用户或机构得将EMHUB标识以任何方式展示、使用或做其他处理。
    </p>
    <p class="mt-2">
      2．本应用涉及广告的知识产权除由相应的广告商享有外，EMHUB在本服务中提供的内容，包括：文字、图片、网页等均归EMHUB所有。本应用所转载第三方内容，包括：文字、图片、视频等均已与版权方协商并获其授权，用户对其不得以复制、打印等方式获取，并用于商业目的。
    </p>
    <p class="mt-2">
      3．凡EMHUB授权用户所产生的包括：文章、图片、视频等资料的版权归版权所有人所有，如需转载，请与原创作者联系，经双方协商达成一致后，方可转载使用；未与原创作者协商的，用户不得擅自转载。如原创作者认为其作品不宜在本应用公开的，请及时联系EMHUB客服，EMHUB会及时采取适当的措施，避免给双方造成不必要的经济损失。
    </p>
    <p class="mt-5"><strong>五、服务暂停、变更或中止</strong></p>
    <p class="mt-2">
      EMHUB平台有权根据需要不定时制订，如本协议有任何变更，EMHUB将在网站重要页面提示修改内容或通过邮件、短信等形式告知用户。如用户不同意相关变更，可停止使用EMHUB平台的网络服务。修订的协议一经在EMHUB网站公布，即刻生效，并成为本协议的一部分。登录或继续使用EMHUB网络服务表示该用户已经接受修订的协议。若有下列情况，EMHUB将中止服务：
    </p>
    <p class="mt-2">
      1．因EMHUB需要定期或不定期地对提供本服务的平台或相关的设备进行检修或者维护，在此类情况下造成本服务在合理时间内的中断，EMHUB无需为此承担任何责任，但EMHUB因尽可能事先进行通告。
    </p>
    <p class="mt-2">
      2．在EMHUB发展期间，平台各业务模块可能会出现增加、删除、迭代等，因此对应EMHUB服务条款也会出现变更或暂停等，EMHUB对此应尽量告知用户，但因此发生的任何纠纷，EMHUB不承担任何责任。
    </p>
    <p class="mt-2">3．在服务生效期间，EMHUB如发现用下述情况，EMHUB有权随时中断或终止向您提供本服务，且无需对您或任何第三方承担任何责任：</p>
    <p class="mt-2">（1）您所提供的个人资料不真实；</p>
    <p class="mt-2">（2）违反EMHUB的内容发布政策或违反本协议约定；</p>
    <p class="mt-2">（3）其他EMHUB认为不适宜的地方。</p>
    <p class="mt-5"><strong>六、免责条款</strong></p>
    <p class="mt-2">
      1．本服务在遇到不可抗力等风险因素，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为等。出现上述情况时，希望可以得到理解，EMHUB将努力在第一时间与相关单位配合，及时进行修复，由此给用户或第三方造成的损失，EMHUB无须承担任何责任。
    </p>
    <p class="mt-2">
      2．本服务如有因用户原因、网络服务质量、网络通讯故障、社会环境等因素的差异造成的网络安全问题或第三方因素，EMHUB对此不承担责任。用户应正确使用并加强信息安全及个人资料的保护意识，以免遭致损失和骚扰。
    </p>
    <p class="mt-2">
      3、在服务期间，EMHUB需要定期或不定期地对平台或相关的设备进行检修或者维护，如因此类情况而造成服务在合理时间内的中断，EMHUB无需为此承担任何责任，但EMHUB因尽可能事先进行通告。
    </p>
    <p class="mt-2">4．EMHUB依据法律法规、本协议约定获得处理违法违规或违约内容的权利，该权利不构成EMHUB的义务或承诺，EMHUB不能保证及时发现违法违规或违约行为或进行相应处理。</p>
    <p class="mt-2">5．在EMHUB向用户所提供所有免费服务中，如出现质量缺陷而引发的任何损失，EMHUB无须承担任何责任。</p>
    <p class="mt-5"><strong>七、纠纷解决</strong></p>
    <p class="mt-2">1．如双方就本协议内容或服务中发生任何争执，双方应先协商解决；如果协商未果，任何一方均可向EMHUB所在地的人民法院提起诉讼。</p>
    <p class="mt-2">2．本协议的修订、执行和纠纷的解决均适用中华人民共和国法律。</p>
    <p class="mt-2">3．服务条款所涉及到的纠纷解释权归EMHUB所有。</p>
    <p class="text-right mt-2">北京欧心医联医疗科技有限公司</p>
    <p class="text-right mt-2">2022年4月25日</p>
  </div>
</template>

<script>
export default {
  name: "userAgree"
}
</script>

<style scoped>

</style>